const HouseWithFlag = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='157'
    height='189'
    viewBox='0 0 157 189'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.994 58.798h130v130h-130v-130Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m127.212 132.577-101.317-7.084 3.544-50.657 101.315 7.084-3.542 50.657Z'
      fill='#FFD2A9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m86.686 129.743-20.263-1.416 2.656-37.994a2.547 2.547 0 0 1 2.71-2.355l15.196 1.061a2.55 2.55 0 0 1 2.358 2.71l-2.657 37.994Z'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M75.261 111.127a2.54 2.54 0 1 1-5.067-.354 2.54 2.54 0 0 1 5.067.354'
      fill='#FFA926'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m56.999 117.486-20.263-1.417 2.126-30.395 20.263 1.418-2.126 30.394ZM117.788 121.737l-20.263-1.416 2.125-30.395 20.265 1.418-2.127 30.393Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M62.996 35.886c-.39 5.594-5.244 9.813-10.839 9.423-5.595-.392-9.815-5.244-9.424-10.84.393-5.595 5.245-9.815 10.84-9.423 5.596.391 9.816 5.245 9.423 10.84Z'
      fill='#FFCF0E'
    />
    <mask
      id='house-with-flag__a'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='33'
      width='62'
      height='24'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M.791 33.88h60.811v22.269H.791V33.88Z'
        fill='#fff'
      />
    </mask>
    <g mask='url(#house-with-flag__a)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M52.277 45.76c-1.142-.08-2.25.038-3.298.311-1.31-6.517-6.97-11.654-14.108-12.152-6.43-.45-12.206 2.989-14.9 8.259a12.979 12.979 0 0 0-5.616-1.727C7.341 39.962 1.266 45.086.79 51.898l17.24 1.206 8.165.57 15.423 1.08 3.631.253 16.33 1.143c.375-5.352-3.79-10.004-9.302-10.389'
        fill='#91C5F0'
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M130.754 81.92 29.439 74.836l2.125-30.395 101.315 7.085-2.125 30.394Z'
      fill='#754C24'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m50.493 61.033 1.772-25.328 10.132.709-1.773 25.328-10.13-.71Z'
      fill='#754C24'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m120.1 157.532-10.131-.708L123.128 5.029l5.066.354-8.094 152.149Z'
      fill='#EFEFEF'
    />
    <mask
      id='house-with-flag__b'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x='124'
      y='5'
      width='33'
      height='23'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M124.519 5.224h31.811v22.39h-31.811V5.224Z'
        fill='#fff'
      />
    </mask>
    <g mask='url(#house-with-flag__b)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m154.913 27.614-30.394-2.127 1.417-20.263 30.394 2.127-1.417 20.263Z'
        fill='#FF620F'
      />
    </g>
    <mask
      id='house-with-flag__c'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x='120'
      y='0'
      width='12'
      height='11'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M120.858.146h10.156v10.157h-10.156V.146Z'
        fill='#fff'
      />
    </mask>
    <g mask='url(#house-with-flag__c)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M131.002 5.579a5.079 5.079 0 1 1-10.143-.546 5.079 5.079 0 0 1 10.143.546Z'
        fill='#FFCF0E'
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M97.099 188.798H46.751l19.672-60.471 20.263 1.416 10.413 59.055Z'
      fill='#E1E1E1'
    />
  </svg>
);

export default HouseWithFlag;
